
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/konstruktor",
      function () {
        return require("private-next-pages/archive/konstruktor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/konstruktor"])
      });
    }
  